import Link from 'next/link'
import { Button } from '@/components/ui/button'

interface ClientBigPromoCardProps {
  buildLoginRedirect: (target: string) => string
  isVisible: boolean
}

export default function ClientBigPromoCard({ buildLoginRedirect, isVisible }: ClientBigPromoCardProps) {
  const registrationHref = buildLoginRedirect('/client/projects/new?from=landing_promo_primary')

  return (
    <section
      className={`w-full bg-white px-0 py-16 sm:px-6 md:py-20 lg:px-8 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {/* ✅ 모바일: w-full(꽉참) / sm+: max-width 중앙정렬 */}
      <div className="w-full sm:mx-auto sm:max-w-6xl">
        {/* ✅ 모바일: 라운드 없음 / sm+: 라운드 적용(원하면 sm:rounded-3xl 삭제 가능) */}
        <div className="overflow-hidden bg-zinc-950 text-white sm:rounded-3xl">
          <div className="grid gap-8 p-8 md:grid-cols-2 md:items-center md:gap-12 md:p-12">
            {/* Left: 메시지 + 근거 */}
            <div className="space-y-4">
              <h2 className="text-3xl font-bold md:text-4xl">
                원하는 팀이 없어도 부담 없이 시작하세요
              </h2>
              <p className="text-lg text-gray-300">
                요청만 먼저 보내고 비교만 해도 됩니다. 팀 선택은 원할 때 진행하세요.
              </p>
              
              {/* 미니 포인트 칩 3개 */}
              <div className="flex flex-wrap gap-2 pt-2">
                <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                  3분 등록
                </span>
                <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                  요청 10회 무료
                </span>
                <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                  선택 의무 없음
                </span>
              </div>
            </div>

            {/* Right: CTA + 마이크로카피 */}
            <div className="flex flex-col items-center justify-center gap-3 md:items-end">
              <Button
                asChild
                size="lg"
                className="h-14 rounded-xl bg-blue-600 px-10 text-white shadow-md transition-all hover:bg-blue-700 hover:shadow-lg font-semibold text-base whitespace-nowrap"
              >
                <Link href={registrationHref}>
                  무료로 견적 요청 시작하기
                </Link>
              </Button>
              <p className="text-sm text-gray-400 text-center md:text-right">
                요청 후 바로 선택하지 않아도 괜찮아요
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

